export const PALETTE = ['#1e3a8a', '#0f766e', '#b45309', '#7c2d12', '#4338ca', '#047857', '#be123c', '#0369a1', '#6d28d9', '#a16207', '#94a3b8'];

export const norm = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const eur = (v) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);

export const slug = (s) => norm(String(s).replace(/Œ/g, 'OE').replace(/œ/g, 'oe')).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const aplatir = (contrats) => contrats.flatMap((c) => c.activites.map((a) => ({ ...a, id: c.id, annee: c.annee, territoire: c.territoire, ca: c.ca, contrats: 1 })));

export function totaux(lignes) {
  const ids = new Set(lignes.map((l) => l.id));
  const ca = new Map(lignes.map((l) => [`${l.id}|${l.territoire}`, l.ca]));
  return { contrats: ids.size, ca: [...ca.values()].reduce((s, v) => s + v, 0) };
}

export const libelle = (a) => `${a.code} · ${a.nom}`;

export function filtrer(lignes, f) {
  const q = norm(f.recherche).trim();
  return lignes.filter((l) => (!f.annees.length || f.annees.includes(l.annee))
    && (!f.territoires.length || f.territoires.includes(l.territoire))
    && (!f.categories.length || f.categories.includes(l.categorie))
    && (!q || q.split(/\s+/).every((m) => norm(`${l.code} ${l.nom}`).includes(m))));
}

export function parActivite(lignes, mesure) {
  const m = new Map();
  lignes.forEach((l) => {
    const k = l.code;
    const cur = m.get(k) || { code: l.code, nom: l.nom, categorie: l.categorie, contrats: 0, ca: 0, territoires: new Set() };
    cur.contrats += l.contrats; cur.ca += l.ca; cur.territoires.add(l.territoire);
    m.set(k, cur);
  });
  return [...m.values()].sort((a, b) => b[mesure] - a[mesure]);
}

export function topEtAutres(classement, mesure, n = 10) {
  const top = classement.slice(0, n).map((a) => ({ name: libelle(a), value: a[mesure] }));
  const reste = classement.slice(n).reduce((s, a) => s + a[mesure], 0);
  return reste > 0 ? [...top, { name: 'Autres activités', value: reste }] : top;
}

export function croise(lignes, cle, codes, mesure, avecAutres = true) {
  const m = new Map();
  lignes.forEach((l) => {
    const row = m.get(l[cle]) || Object.fromEntries([[cle, l[cle]], ...codes.map((c) => [c, 0])]);
    const k = codes.includes(l.code) ? l.code : 'Autres';
    if (k === 'Autres' && !avecAutres) { m.set(l[cle], row); return; }
    row[k] = (row[k] || 0) + l[mesure];
    m.set(l[cle], row);
  });
  return [...m.values()].sort((a, b) => (cle === 'annee' ? a.annee - b.annee : String(a[cle]).localeCompare(String(b[cle]), 'fr')));
}

export function exporterCsv(classement, f) {
  const entete = ['Rang', 'Code', 'Activité', 'Catégorie', 'Contrats', 'CA des contrats incluant l\'activité (EUR)', 'Territoires'];
  const lignes = classement.map((a, i) => [i + 1, a.code, a.nom, a.categorie, a.contrats, a.ca.toFixed(2), [...a.territoires].join(' / ')]);
  const filtres = `Filtres : années ${f.annees.join(', ') || 'toutes'} ; territoires ${f.territoires.join(', ') || 'tous'} ; catégories ${f.categories.join(', ') || 'toutes'}`;
  const csv = [[filtres], entete, ...lignes].map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(';')).join('\n');
  const url = URL.createObjectURL(new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url; a.download = `activites-souscrites-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
  URL.revokeObjectURL(url);
}

export async function exporterPdf(noeud) {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import('html2canvas'), import('jspdf')]);
  const canvas = await html2canvas(noeud, { scale: 2, backgroundColor: '#ffffff' });
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const w = 277; const pagePx = Math.floor((190 * canvas.width) / w);
  const tranche = document.createElement('canvas');
  tranche.width = canvas.width;
  for (let y = 0, i = 0; y < canvas.height; y += pagePx, i += 1) {
    const hPx = Math.min(pagePx, canvas.height - y);
    tranche.height = hPx;
    const ctx = tranche.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, tranche.width, hPx);
    ctx.drawImage(canvas, 0, y, canvas.width, hPx, 0, 0, canvas.width, hPx);
    if (i) pdf.addPage();
    pdf.addImage(tranche.toDataURL('image/jpeg', 0.85), 'JPEG', 10, 10, w, (hPx * w) / canvas.width);
  }
  pdf.save(`activites-souscrites-${new Date().toISOString().slice(0, 10)}.pdf`);
}
